// removed by extract-text-webpack-plugin
module.exports = {"Coconut":"#F4F7FA","White":"#FFFFFF","pageContainer":"Gbe17ed","headerContainer":"G547b5d"};